import { getContractAudioURL } from "../api/customers";
import { APIContract, Contract, User } from "../types";

export function convertContractFromAPI(apiContract: APIContract, user: User): Contract {
    return {
        id: apiContract.transactionId,
        date: apiContract.dateCreated,
        data: getContractAudioURL(user, apiContract.transactionId),
    };
}